/* Requiere de genesys.js */

var articulo = {
	data () {
		return {
            listArticulos: [],
            searchArticulos: ''
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		getArticulos() {
            let search = (this.searchArticulos.length == 13 && !isNaN(this.searchArticulos.trim())) ? String(this.searchArticulos).substring(3, 13) : this.searchArticulos
            let url = this.urlAPIArticulo + '/get?search=' + search
			console.log(url)
            this.axios.get(url)
                .then(response => { this.getArticulosResult(response); })
                .catch(error  => { console.log(error); alert(error); })
        },
        getArticulosResult(response) {
            console.log(response)
            this.listArticulos = response.data.data
        }
	},
};

export default articulo;